import {FC, useState, useEffect} from 'react'
import clsx from 'clsx'
import find from 'lodash/find'
import {simpleCurrency} from 'app/format/currency'
import ProductImage from 'app/components/products/ProductImage'
import {truncate} from 'lodash'
import {useDispatch, useSelector} from 'react-redux'
import {addVariant, removeVariant} from 'app/features/orders/redux/product/searchProductSlice'
import {RootState} from 'setup'

type Props = {
  variant: any
  product: any
}

const VariantListItem: FC<Props> = ({variant, product}) => {
  const dispatch = useDispatch()
  const [canSelect, setCanSelect] = useState(true)

  const selectedVariants: any = useSelector<RootState, any[]>(
    ({orders}) => orders.product.selectedVariants
  )
  const orderItems: any = useSelector<RootState, any[]>(({orders}) => orders.product.existingItems)

  useEffect(() => {
    if (orderItems.length > 0) {
      const orderItem = find(orderItems, {variantId: variant.id})
      if (orderItem) {
        setCanSelect(false)
      } else {
        setCanSelect(true)
      }
    }
  }, [orderItems, variant.id])

  const handleSelect = (e: any) => {
    const {checked} = e.target
    if (checked) {
      const {name, imageSrc} = product
      dispatch(addVariant({...variant, product: {name, imageSrc}}))
    } else {
      dispatch(removeVariant(variant.id))
    }
  }

  const checked = () => {
    const selectedVariant = find(selectedVariants, {id: variant.id})
    return !!selectedVariant
  }

  return (
    <>
      <div className='d-flex justify-content-between align-items-center mx-4'>
        <div className='d-flex align-items-center ms-2'>
          <div className='form-check form-check-sm form-check-custom form-check-solid me-4'>
            {canSelect && (
              <input
                id={'chk' + variant.name}
                disabled={!canSelect}
                className='form-check-input widget-9-check'
                onChange={handleSelect}
                type='checkbox'
                checked={checked()}
              />
            )}

            {!canSelect && (
              <input
                id='chkvaraiant'
                disabled={true}
                className='form-check-input widget-9-check'
                type='checkbox'
                checked={true}
              />
            )}
          </div>
          <div className='d-flex align-items-center'>
            <div className='symbol symbol-50px ms-5 me-5'>
              <ProductImage product={product} />
            </div>

            <div className='d-flex justify-content-start flex-column'>
              <span className='text-dark fw-bolder text-hover-primary mb-1 fs-6'>
                {truncate(product.name, {length: 40})}
              </span>
              {variant.name !== 'Default' && (
                <span className='text-muted fw-bold text-muted d-block fs-7'>{variant.name}</span>
              )}
            </div>
          </div>
        </div>
        <div className='text-end d-flex flex-column mx-5'>
          <span className={clsx('fw-bold fs-6 text-gray-800')}>
            <span
              className={clsx(
                variant.discountPrice > 0 && 'text-decoration-line-through me-5 text-danger'
              )}
            >
              {simpleCurrency(variant.price)}
            </span>
            {variant.discountPrice > 0 && <span>{simpleCurrency(variant.discountPrice)}</span>}
          </span>
        </div>
      </div>
      <div className='separator my-3'></div>
    </>
  )
}

export default VariantListItem
